/* @ngInject */

export default (
  $rootScope,
  $scope,
  webpage,
  eventService,
  Field,
  fieldService,
  fieldsService,
  actionService
) => {
  $scope.Model = {
    availableFields: [],
    entity: 'ticket',
    fieldsList: null,
    watcher: null,
    isArchive: false,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  const loadFields = () => {
    webpage.pageTitle('Loading, please wait');
    fieldsService
      .getAvailable({ entity: $scope.Model.entity, isActive: !$scope.Model.isArchive })
      .then((data) => {
        // Set Model values
        $scope.Model.availableFields = data;
      })
      .then(() => {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Custom fields : Settings');
        $scope.Model.isReady = true;
      });
  };

  if ($rootScope.CurrentAccount.isAdministrator) {
    loadFields();
  }

  /*
   * Events available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.$on('fieldDelete', () => {
    fieldsService.clearCache();
    actionService.deleteDocuments(
      $scope.Model.fieldsList.getSelected(),
      fieldService.deleteField,
      $scope.Model.fieldsList.removeData,
      'custom field(s)'
    );
  });

  $scope.$on('fieldDuplicate', () => {
    fieldsService.clearCache();
    actionService.duplicateDocuments(
      $scope.Model.fieldsList.getSelected(),
      fieldService.readField,
      fieldService.createField,
      $scope.Model.fieldsList.setDataAppend,
      'name',
      ' copy',
      'custom field(s)'
    );
  });

  $scope.$on('fieldActivate', () => {
    fieldsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.fieldsList.getSelected(),
      fieldService.updateField,
      $scope.Model.fieldsList.removeData,
      'custom field(s)',
      true
    );
  });

  $scope.$on('fieldArchive', () => {
    fieldsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.fieldsList.getSelected(),
      fieldService.updateField,
      $scope.Model.fieldsList.removeData,
      'custom field(s)',
      false
    );
  });

  $scope.$on('fieldAdd', (e, $event, fieldType) => {
    fieldsService.clearCache();
    eventService.fieldEdit({ event: $event, fieldType, list: $scope.Model.fieldsList });
  });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.fieldEdit = ($event, field) => {
    eventService.fieldEdit({ event: $event, field, list: $scope.Model.fieldsList });
  };
  $scope.fieldEdited = (fieldToEdit) => {
    const field = fieldToEdit;
    fieldsService.clearCache();
    if (field.isNew === true) {
      delete field.isNew;
      if (field.isActive !== $scope.Model.isArchive) {
        $scope.Model.fieldsList.setDataAppend(field);
      }
    } else {
      $scope.Model.fieldsList.setDataReplace(field);
    }
  };

  $scope.listChange = (list, data, isSelected) => {
    $scope.$parent.Model.childStateHasSelection = isSelected || list.isSelectedAny();
  };

  $scope.listReady = (list) => {
    $scope.Model.fieldsList = list;
    $scope.Model.watcher = $scope.$parent.$watch(
      'Model.childStateIsArchive',
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          $scope.Model.isArchive = newValue;
          $scope.Model.isReady = false;
          $scope.Model.watcher();
          loadFields();
        }
      }
    );
  };
};
